export const SPLITTABLE_ENS_MEMEBER = "member:0-50";
/**
 * "member:0" represents the control run of ENS model.
 * See: https://www.meteomatics.com/en/api/request/optional-parameters/ensemble-member-selection/#ensemble_member_selection
 */
export const ENS_MEMBER_WITH_PAST_DATA = "member:0";
export const SPLITTED_ENS_MEMEBERS = [ENS_MEMBER_WITH_PAST_DATA, "member:1-50"];
